module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-audio-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.startPlay($event)
      }
    }
  }, [_vm._t("default"), _vm._v(" "), _c('audio', {
    staticClass: "vue-audio",
    attrs: {
      "muted": _vm.muted,
      "autoplay": _vm.autoplay,
      "preload": _vm.preload,
      "src": _vm.source,
      "loop": _vm.loop
    },
    on: {
      "ended": _vm._ended,
      "playing": _vm._playing,
      "pause": _vm._pause,
      "error": _vm._error,
      "timeupdate": _vm._timeupdate,
      "waiting": _vm._waiting
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-505a2eb6!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/audio.vue
// module id = 11
// module chunks = 1